export const breakpoints = {
  sm: '576px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
};
